import api from './api';

export async function login(pin) {
  const response = await api.post(
    '/auth/login',
    { pin },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  const { token, refreshToken, role, roles, employeeId } = response.data;

  localStorage.setItem("token", token);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);

  return { token, refreshToken, role, roles, employeeId };
}
